import { render } from "./DocumentSender.vue?vue&type=template&id=423c120b"
import script from "./DocumentSender.vue?vue&type=script&lang=js"
export * from "./DocumentSender.vue?vue&type=script&lang=js"

import "./DocumentSender.vue?vue&type=style&index=0&id=423c120b&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__